import { isEntity } from '@tunasong/schemas'
import type { Entity } from '@tunasong/schemas'
import type { Meter } from '../song/meter.js'

export interface Score extends Entity {
  type: 'score'
  staves: unknown[]
  /* The DSL text string for the score */
  lang: string
  /**
   * The meter the score is engraved and played in (GH #1984). "Show as staff" sets it from the
   * melody, whose bars `lang` was cut in. Absent on blocks saved before it existed: those use the
   * song's meter, as they always did.
   */
  meter?: Meter
}

export function isScore(node?: unknown): node is Score {
  return Boolean(isEntity(node) && node.type === 'score')
}
